module.exports = __webpack_public_path__ + "img/orange-header-en.5e9ed0db.png";